import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface SummaryKPIsProps {
  totalCostCents: number
  averageCostPerEmployeeCents: number
  uniqueEmployees: number
  dependentEnrollmentsCount: number
  totalEmployees: number
  adoptionRate: number
}

export const SummaryKPIs = React.memo(function SummaryKPIs({
  totalCostCents,
  averageCostPerEmployeeCents,
  uniqueEmployees,
  dependentEnrollmentsCount,
  totalEmployees,
  adoptionRate,
}: SummaryKPIsProps) {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Box gap="s16" flexDirection="row" flexWrap="wrap">
      {/* Total Cost Card */}
      <Box
        padding="s16"
        background="grey100"
        gap="s8"
        flexDirection="column"
        style={{ minWidth: '200px', flex: '1' }}
      >
        <Text size="100" color="grey600">
          {i18n.t('benefits.healthcare.management.kpis.total_costs')}
        </Text>
        <Text size="400" weight="bold">
          {MoneyWithCurrency({ amount: totalCostCents, locale, currency: 'EUR' })}
        </Text>
        <Text size="100" color="grey600">
          {i18n.t('benefits.healthcare.management.kpis.summary', {
            employees: uniqueEmployees,
            dependents: dependentEnrollmentsCount,
            total: uniqueEmployees + dependentEnrollmentsCount,
          })}
        </Text>
      </Box>

      {/* Average Cost Card */}
      <Box
        padding="s16"
        background="grey100"
        gap="s8"
        flexDirection="column"
        style={{ minWidth: '200px', flex: '1' }}
      >
        <Text size="100" color="grey600">
          {i18n.t('benefits.healthcare.management.kpis.average_cost')}
        </Text>
        <Text size="400" weight="bold">
          {MoneyWithCurrency({ amount: averageCostPerEmployeeCents, locale, currency: 'EUR' })}
        </Text>
        <Text size="100" color="grey600">
          {i18n.t('benefits.healthcare.management.kpis.based_on', { count: uniqueEmployees })}
        </Text>
      </Box>

      {/* Adoption Rate Card */}
      <Box
        padding="s16"
        background="grey100"
        gap="s8"
        flexDirection="column"
        style={{ minWidth: '200px', flex: '1' }}
      >
        <Text size="100" color="grey600">
          {i18n.t('benefits.healthcare.management.kpis.adoption_rate')}
        </Text>
        <Text size="400" weight="bold">
          {adoptionRate.toFixed(1)}%
        </Text>
        <Text size="100" color="grey600">
          {uniqueEmployees} 👤 / {totalEmployees} 👤
        </Text>
      </Box>
    </Box>
  )
})
